var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "lf-counter-wrapper" }, [
    _c("div", { staticClass: "text-wrapper" }, [
      _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.info.title))]),
    ]),
    _c("span", { staticClass: "number" }, [_vm._v(_vm._s(_vm.info.qty))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }